/**
 * Created by igor.kulishov on 2/1/2017.
 */
(function () {

  'use strict';

  angular
    .module('app.search')
    .directive('searchResultsTable', [function(){
      return {
        controller: ['$scope', function($scope) {
          $scope.fadeout = false;
          this.backgroundFadeout = function(msg) {
           msg ? ($scope.fadeout = true) : ($scope.fadeout = false);
          }
        }]
      };
    }])
    .directive('thumbnailImg',[ '$timeout', function($timeout){

      return {
        require: '^^?searchResultsTable',
        scope: {
            imageurl: '@',
            languagecode: '@'
        },
        link : function (scope, element, attrs, ctrl) {
            scope.enlarge = false;
            if (scope.imageurl) {
              scope.imageurllarge = scope.imageurl.replace(/th/i, 'dt');
            }

            var timer;
            // mouseenter event
            scope.enlargeIt = function () {
              timer = $timeout(function () {
                scope.enlarge = true;
                ctrl.backgroundFadeout(true);
              }, 500);
            };
            // mouseleave event
            scope.decreaseIt = function () {
              $timeout.cancel(timer);
              scope.enlarge = false;
              ctrl.backgroundFadeout(false);
            };
        },
        templateUrl: 'app/search/directives/thumbnails/thumbnail.directive.html'
      };
    }]);
})();



// WEBPACK FOOTER //
// ./app/search/directives/thumbnails/thumbnail.directive.js